import React from 'react';
import AdminDashboard from './AdminDashboard';

const GlobalDashboardContainer = () => <AdminDashboard />;

export default GlobalDashboardContainer;
